import { render, staticRenderFns } from "./sidebar-options.vue?vue&type=template&id=ad2b0104&scoped=true&"
import script from "./sidebar-options.vue?vue&type=script&lang=js&"
export * from "./sidebar-options.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-options.vue?vue&type=style&index=0&id=ad2b0104&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2b0104",
  null
  
)

export default component.exports